import { DocumentFile } from './document-file';
import { DocumentLockStatus } from './document-lock-status';
import { ShareBaseItem } from './sharebase-item';

export interface ShareBaseDocument extends ShareBaseItem {
    DocumentId: number;
    DocumentName: string;
    DocumentAutoName: string;
    DateModified: string | Date;
    FileSize: number;
    MimeType: string;
    VersionNumber: number;
    FileFormat: string;
    Icon: string;
    IsFavorite:boolean;
    Owner: string;
    Links: {
      Self: string;
      Revisions: string;
      Tags: string;
      RelatedTags: string;
      ContentUri: string;
      ContentUri_v2: string;
      SharesUri: string;
      CommentsUri: string;
      WriteACLCheckUri: string;
      PermissionsUri: string;
      EditPermissionsUri: string;
      ShareWithUsersOrGroupsUri: string;
      ThumbnailUri: string;
      ActivitiesUri: string;
      MailSharedUsersUri: string;
      SubscribersUri: string;
      NotificationSettingsUri: string;
    };
    Embedded: {
      LatestFile: DocumentFile;
      Path: any[];
      LockStatus: DocumentLockStatus;
    };
    RecentView?:Date;
    HasActiveTasks?:boolean;
  }

  export function isShareBaseDocument(item:any): item is ShareBaseDocument {
    return item && angular.isDefined(item.DocumentId);
  }


// WEBPACK FOOTER //
// ./src/phoenix/domain/sharebase-document.ts